var _circle, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelescope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 231,
    viewBox: "0 0 260 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 123,
    cy: 108,
    r: 108,
    fill: "#B9B9B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 182.5L62.5 170L71 160.5L95.5 145.188L111 135.5L118 127L140 114L151 107.5L168 133.5L157 140.438L135.5 154L124.5 157L109.49 166.5L85 182L72 185.5L61.9535 189.965L54 193.5L43 188.5L38.5 192L34 185.5L35.5 183.5L39.5 184.5V182.5H47Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 182.5L62.5 170M47 182.5H39.5V184.5L35.5 183.5L34 185.5L38.5 192L43 188.5L54 193.5M47 182.5L54 193.5M62.5 170L71 160.5M62.5 170L72 185.5M71 160.5L85 182M71 160.5L95.5 145.188M111 135.5L118 127M111 135.5L124.5 157M111 135.5L95.5 145.188M118 127L135.5 154M118 127L140 114M135.5 154L124.5 157M135.5 154L157 140.438M124.5 157L109.49 166.5M85 182L72 185.5M85 182L109.49 166.5M72 185.5L54 193.5M140 114L151 107.5L168 133.5L157 140.438M140 114L157 140.438M95.5 145.188L109.49 166.5M60 185.5L63.5 193.5L57.5 196.5",
    stroke: "#383434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71 160.5L62.5 170L72 185.5L85 182L71 160.5Z",
    fill: "#12D9E3",
    stroke: "#12D9E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 127L111 135.5L124.5 157L135.5 154L118 127Z",
    fill: "#12D9E3",
    stroke: "#12D9E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168 133.5L151 107.5L140 114L157 140.438L168 133.5Z",
    fill: "#12D9E3",
    stroke: "#12D9E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 190,
    width: 12,
    height: 5,
    rx: 2.5,
    fill: "#F2CA00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 164,
    width: 6,
    height: 26,
    rx: 3,
    fill: "white",
    stroke: "#383434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 230H82",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101 230L259 230",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 195L74.759 226.852C74.156 228.36 75.2663 230 76.89 230C77.8563 230 78.7191 229.395 79.0481 228.486L89 201L98.9978 228.613C99.2992 229.445 100.09 230 100.975 230C102.441 230 103.457 228.538 102.947 227.165L91 195H87.5Z",
    fill: "#F2CA00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.766 135V140.498",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209 137.625H214.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7656 57V62.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53 59.625H58.5156",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.766 19V24.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130 21.625H135.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76562 115V120.498",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 117.625H6.51562",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M244.766 54V59.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M242 56.625H247.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.766 78V83.4983",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M145 80.625H150.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.766 180V185.498",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M121 182.625H126.516",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescope);
export default __webpack_public_path__ + "static/media/telescope.ef615ecb54f572733005b13d12306043.svg";
export { ForwardRef as ReactComponent };